import { useState, useEffect } from "react";

import { Liferay } from './common/services/liferay/liferay.js';
import api from './common/services/liferay/api.js';
import { Retribucion } from './common/components/Retribucion';
import { Filters } from "./common/components/Filters";

export const App = ({ contentStructureId, aniosCategoryId, showFirstOpen }) => {
    const [anios, setAnios] = useState([]);
    const [retribuciones, setRetribuciones] = useState([]);
    const [filterRetribuciones, setFilterRetribuciones] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // Filtramos las retribuciones por anio o resetemaos a los ultimos 4 anios
    const getRetribuciones = (selectedAnio, allAnios = anios, allRetribuciones = retribuciones) => {
        // Helper para obtener el año numérico asociado a una retribución
        const getAnioFromRetribucion = (retribucion) => {
            const match = retribucion.taxonomyCategoryBriefs?.find((brief) =>
                allAnios.some((a) => String(a.id) === String(brief.taxonomyCategoryId))
            );
            const anioCat = allAnios.find(a => String(a.id) === String(match?.taxonomyCategoryId));
            return anioCat ? parseInt(anioCat.name, 10) : null;
        };

        let filteredRetribuciones;

        if (!selectedAnio) {
            // Obtener los 4 últimos años
            const years = allAnios
                .map(a => parseInt(a.name, 10))
                .filter(year => !isNaN(year))
                .sort((a, b) => b - a);

            const latestYears = years.slice(0, 4);

            const latestYearCategoryIds = allAnios
                .filter(a => latestYears.includes(parseInt(a.name, 10)))
                .map(a => a.id);

            filteredRetribuciones = allRetribuciones.filter(retribucion =>
                retribucion.taxonomyCategoryBriefs?.some(brief =>
                    latestYearCategoryIds.includes(String(brief.taxonomyCategoryId))
                )
            );
        } else {
            // Filtrar por año seleccionado
            filteredRetribuciones = allRetribuciones.filter(retribucion =>
                retribucion.taxonomyCategoryBriefs?.some(
                    (brief) => String(brief.taxonomyCategoryId) === String(selectedAnio.id)
                )
            );
        }

        //Ordenar las retribuciones por año (descendente)
        filteredRetribuciones.sort((a, b) => {
            const yearA = getAnioFromRetribucion(a) || 0;
            const yearB = getAnioFromRetribucion(b) || 0;
            return yearB - yearA;
        });

        setFilterRetribuciones(filteredRetribuciones);
        return filteredRetribuciones;
    };

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);

            try {
                const [aniosRes, retribucionesRes] = await Promise.all([
                    api(`o/headless-admin-taxonomy/v1.0/taxonomy-vocabularies/${aniosCategoryId}/taxonomy-categories`)
                        .then((res) => res.json()),
                    api(`o/headless-delivery/v1.0/content-structures/${contentStructureId}/structured-contents`)
                        .then((res) => res.json()),
                ]);

                const aniosData = aniosRes.items || [];
                const retribucionesData = retribucionesRes.items || [];

                setAnios(aniosData);
                setRetribuciones(retribucionesData);

                const filtered = getRetribuciones(null, aniosData, retribucionesData);
                setFilterRetribuciones(filtered);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [contentStructureId, aniosCategoryId]);

    useEffect(() => {
        if (isLoading) return;

        const accordions = document.querySelectorAll(".aena-dynamic-accordion");

        accordions.forEach((accordion) => {
            const triggers = accordion.querySelectorAll(".acc-trigger");

            triggers.forEach((trigger) => {
                const newTrigger = trigger.cloneNode(true);
                trigger.replaceWith(newTrigger);

                newTrigger.addEventListener("click", () => {
                    const isExpanded = newTrigger.getAttribute("aria-expanded") === "true";
                    const panelId = newTrigger.getAttribute("aria-controls");
                    const panel = document.getElementById(panelId);

                    newTrigger.setAttribute("aria-expanded", String(!isExpanded));
                    panel.classList.toggle("is-open", !isExpanded);
                });
            });
        });
    });

    const handleSearch = (selectedAnio) => {
        getRetribuciones(selectedAnio);
    };

    return (
        <div className="aena-searcher">
            <Filters aniosCategoryId={aniosCategoryId} anios={anios} onSearch={handleSearch} />

            {isLoading ? (
                <div></div>
            ) : (
                <section className="aena-grid-container">
                    <ul className="aena-accordion aena-dynamic-accordion">
                        {filterRetribuciones?.map((retribucion, index) => (
                            <Retribucion key={retribucion.id} retribucion={retribucion} index={index} showFirstOpen={showFirstOpen} />
                        ))}
                    </ul>
                </section>
            )}
        </div>
    );
};
